// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1d73180a] .c-input-container-list-item-label {\n  white-space: normal;\n  padding: 3px 0;\n  line-height: 1.2;\n}\n", ""]);
// Exports
module.exports = exports;
